const A = "inserted", c = "removed", o = "not-to-inject", s = (e) => ({
  reviveId: (e == null ? void 0 : e.getAttribute("reviveid")) || (e == null ? void 0 : e.getAttribute("data-reviveid")) || (e == null ? void 0 : e.getAttribute("data-revive-id")) || "",
  zoneId: (e == null ? void 0 : e.getAttribute("zoneid")) || (e == null ? void 0 : e.getAttribute("data-revivezoneid")) || (e == null ? void 0 : e.getAttribute("data-revive-zoneid")) || ""
}), f = (e, n) => {
  const t = document.createElement("ins");
  return t.setAttribute("data-revive-zoneid", n), t.setAttribute("data-revive-id", e), t.setAttribute("style", "display: none"), t;
}, u = ({ zoneId: e, action: n, fullscreen: t }) => {
  setTimeout(
    () => {
      var i;
      (i = window.manipulateBanner) == null || i.call(window, e, n, t), console.info(`[SKY ADV] - window.manipulateBanner invoked on zoneId: ${e}, action: ${n}, fullscreen: ${t}`);
    },
    t ? 1e3 : 0
  );
}, w = (e) => e ? e.dataset.state !== A && e.dataset.state !== o : !1, p = (e) => e ? e.dataset.state !== c : !1, I = (e, n) => {
  if (!e)
    return;
  const { reviveId: t, zoneId: i } = s(e), r = f(t, i);
  n ? n.appendChild(r) : e.appendChild(r);
}, y = (e, n) => {
  var t;
  if (e)
    if (typeof window.reviveAsync > "u")
      console.info("[SKY ADV] window.reviveAsync is undefined");
    else {
      const { reviveId: i } = s(e);
      (t = window.reviveAsync[i]) == null || t.apply(window.reviveAsync[i].detect()), console.info(`[SKY ADV] window.reviveAsync invoked on reviveId: ${i}`), e.dataset.state = A, n == null || n();
    }
}, T = (e, n) => {
  if (!e)
    return;
  const { zoneId: t } = s(e);
  u({ zoneId: t, action: "refresh", fullscreen: n });
}, l = (e) => {
  if (!e)
    return;
  const { zoneId: n } = s(e);
  u({
    zoneId: n,
    action: "destroy"
    /* DESTROY */
  }), e.dataset.state = c;
};
export {
  l as destroyAdv,
  s as getAdvData,
  y as initAdv,
  I as injectAdv,
  T as refreshAdv,
  w as shouldInjectAdv,
  p as shouldRemoveAdv
};
